/* eslint-disable @typescript-eslint/no-explicit-any */
import { post, read } from '@/utils/request';
import type { DetailWithLogs, ListData, SimpleFunc } from 'bv-typings';

export type GoogleTotalAccountInfo = {
  id: string; // 申请id
  isUrgent: number; // 是否加急
  accountNum: number; // 开户数量
  accounts: string[]; // 账户IDs
  isBack: number; // 申请撤回
  settlement: string; // 结算主体
  subject: string; // 开户主体
  subjectShort: string; // 简称
  currency: number; // 币种
  customerType: number; // 客户类型
  secondaryAgencyName: string; // 二代名称
  industry: number; // 行业类型
  productLinks: string; // []产品链接
  timeZone: string; // 时区
  sale: string; // 负责销售
  saleName: string;
  ae: string; // 负责ae
  ourCompany: string; // 我方公司
  applicant: string; // 申请人
  applyTime: string; // 申请开户时间
  approver: string; // 审批人
  approveTime: string; // 审批时间
  aeNote: string; // ae备注
  customerNote: string; // 客户备注
  pushStatus: number; // 推送状态
  pushFailReason?: string;
  upcomingAe: string; // 待办ae
  dataSource: number; // 数据来源
  applyStatus: number; // 申请状态
  rejectReason?: string; // 驳回原因
  failReason?: string;
  onSuccess?: SimpleFunc;
  billingName: string;
  signId?: number; // 签约ID
};

const baseUrl = 'gg_account_opening/full_opening';

async function getTotalList(params: any, signal: any) {
  return read<ListData<GoogleTotalAccountInfo>>(baseUrl, params, undefined, undefined, { signal });
}

type GoogleTotalAccountDetail = DetailWithLogs<{
  id: string;
  settlement: string;
  ourCompany: number;
  paymentMethod: number;
  ae: string;
  deliveryArea: number[];
  accounts: string[];
}>;

const getTotalDetail = (id: string) => {
  return read<GoogleTotalAccountDetail>(baseUrl, undefined, '获取详情失败', id);
};

type InitiateOpeningParams = {
  subject: string;
  settlement: string;
  customerType: number;
  secondaryAgencyName: string;
  accountNum: number;
  currency: number;
  ae: string;
  industryType: number;
  paymentMethod: number;
  timeZone: string;
  productLinks: string[];
  deliveryArea: number[];
  aeNote?: number;
};

const initiateOpening = (params: InitiateOpeningParams) => {
  return post(baseUrl, params, '发起开户失败');
};

type ISupplementInfoParams = {
  signId: string;
  paymentName: string;
  sale: number;
  ae: number;
  paymentMethod: number;
};

const supplementInfo = async (params: ISupplementInfoParams, ids?: string[]) => {
  return post('gg_account_opening/complete_info', { info: params, ids }, '补充信息失败');
};

const manualPush = async (ids: string[]) =>
  post('gg_account_opening/push', { ids }, '手动推送失败');

type IBatchNotesParams = {
  ids: string[];
  aeNote: string;
};

const batchNotes = async (params: IBatchNotesParams) =>
  post('gg_account_opening/batch_note', params, '批量备注失败');

type IBatchRejectParams = {
  ids: string[];
  rejectReason: string;
};

const batchReject = async (params: IBatchRejectParams) =>
  post('gg_account_opening/batch_reject', params, '批量驳回失败');

export type IUrgentAuditParams = {
  ids: string[];
};

const expediteOpenAccount = async (params: IUrgentAuditParams) => {
  return post('gg_account_opening/deal_urgent', { ...params, status: 1 }, '批量加急失败');
};

const cancelExpediteOpenAccount = async (params: IUrgentAuditParams) => {
  return post('gg_account_opening/deal_urgent', { ...params, status: 0 }, '批量取消加急失败');
};

export {
  getTotalList,
  getTotalDetail,
  initiateOpening,
  supplementInfo,
  manualPush,
  batchNotes,
  batchReject,
  expediteOpenAccount,
  cancelExpediteOpenAccount,
};
